import React, {ReactNode} from 'react'
import HRVSummaryAutoNervousSystemAPI from 'components/molcules/ProfitSummaryReport/HRV/HRVSummaryAutoNervousSystemAPI'
import HRVSummarySentimentalAPI from 'components/molcules/ProfitSummaryReport/HRV/HRVSummarySentimentalAPI'
import HRVSummaryStressAPI from 'components/molcules/ProfitSummaryReport/HRV/HRVSummaryStressAPI'
import useLanguage from 'features/languageReport/useLanguage'
import {HRVSummaryResponse} from 'api/analysisApi'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

interface HRVSummaryProps extends HRVSummaryResponse {
  CustomerCard?: ReactNode
  tableImage: string
  contourImage: string
  histogramImage: string
  contour: number
  clientFirstName: string
  clientLastName: string
  autoNervousSystemBalance: {
    parasympathetic: number
    sympathetic: number
  }
}

export default function HRVSummaryAPI(props: HRVSummaryProps) {
  const {
    circularImage,
    depression,
    phase,
    anxiety,
    CustomerCard,
    tableImage,
    contourImage,
    histogramImage,
    contour,
    histogram,
    clientFirstName,
    clientLastName,
    reportType,
    autoNervousSystemBalance,
  } = props

  const classes = useStyles()
  const {textHrvAPI} = useLanguage('hrv')
  const currentBalanceStageNumber =
    textHrvAPI?.autonomic_nervous_system_stress_analysis.section
      .automatic_nervous_balance.number ?? 1
  const balanceOpinionText =
    textHrvAPI?.autonomic_nervous_system_stress_analysis.section.automatic_nervous_balance.analysis_results.opinions[
      `stage${currentBalanceStageNumber}`
    ]
      .replace('{1}', String(autoNervousSystemBalance.sympathetic))
      .replace('{2}', String(autoNervousSystemBalance.parasympathetic)) ?? ''
  return (
    <div className={classes.root}>
      {CustomerCard}
      {/* Basic analysis */}
      <HRVSummaryAutoNervousSystemAPI
        balanceCircularImagePath={circularImage}
        balanceOpinion={balanceOpinionText}
        tableImagePath={tableImage}
        contourImagePath={contourImage}
        histogramImagePath={histogramImage}
        contour={contour}
        histogram={histogram}
      />
      {/* Premium analysis */}
      {reportType === 'P2' && <HRVSummaryStressAPI phase={phase} />}
      {reportType === 'P2' && (
        <HRVSummarySentimentalAPI
          depression={depression}
          anxiety={anxiety}
          customerFirstName={clientFirstName}
          customerLastName={clientLastName}
        />
      )}

      <p className='Warning'>
        {`${textHrvAPI?.footer[0]} ${textHrvAPI?.footer[1]}`}
      </p>
    </div>
  )
}
